// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --teal: #75D5CD;
  --teal-light: #DCF4F2;
  --teal-dark: #3F9991;
  --purple: #8E75B6;
  --purple-light: #E3DCED;
  --purple-dark: #604987;
  --red: #DE7272;
  --panel-width: 260px;
}

body {
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  color: var(--purple);
  background-color: #f6f6f6;
}

body, html, #app {
  height: 100%;
  margin: 0;
}

body.dragover {
  background-color: var(--teal);
}

* {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

strong {
  font-weight: 900;
}

.root {
  display: flex;
  align-items: stretch;
  height: 100%;
}

path {
  stroke: black;
  fill: transparent;
}

.preview-area {
  position: relative;
  flex: 1 1 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.preview {
  box-shadow: 3px 3px 15px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  background-color: white;
  position: relative;
}

.preview-loader {
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
  color: whitesmoke;
  display: flex;
  font-size: 36px;
  font-weight: bold;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.preview > svg {
  display: block;
  contain: strict;
}

.preview > svg:not(:first-child) {
  position: absolute;
  transform: translateZ(0.001px);
  top: 0;
  left: 0;
}

.dragover .drag-target {
  opacity: 0;
}

.drag-target {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
}

.drag-target-message {
  display: flex;
  justify-content: center;
  align-items: center;
  color: whitesmoke;
  font-weight: bold;
  font-size: 36px;
}

.control-panel {
  position: relative;
  flex: 0 0 var(--panel-width);
  width: var(--panel-width);
  background-color: white;
  overflow-y: auto;

  box-shadow: 3px 3px 15px rgba(0, 0, 0, 0.2);
}

.control-panel-bottom {
  position: fixed;
  bottom: 0;
  width: var(--panel-width);
  padding-bottom: 0.5rem;
  background-color: white;
}

.control-panel-bottom .section-header {
  padding-top: 0.25rem;
}

.saxi-title {
  margin: 0 1rem;
  padding-top: 0.5rem;
  font-size: 36px;
  font-weight: 900;
  text-align: center;
  user-select: none;
}
.disconnected .saxi-title {
  text-decoration-line: line-through;
}

.section-header {
  margin-bottom: 1rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--purple-light);
  font-size: 18px;
  font-weight: 900;
  text-align: center;
  user-select: none;
}

.section-body {
  padding: 0 1rem;
}

/* INPUTS */

form {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

label {
  font-size: 10px;
  text-align: center;
  line-height: 1.6;
  user-select: none;
}

input[type=number] {
  width: 100%;
  padding: 0.3rem;
  margin-bottom: 0.5rem;
  border: 1px solid var(--purple);
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  color: var(--purple);
  background-color: white;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
  outline: none;
}

input[type=checkbox] {
  position: relative;
  appearance: none;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  margin: 0 0.5rem 0 0;
  border: 1px solid var(--purple);
  background-color: white;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
  outline: none;
  cursor: pointer;
}

input[type=checkbox]:checked:after {
  display: block;
  position: absolute;
  top: 3px;
  right: 3px;
  bottom: 3px;
  left: 3px;
  content: '';
  background-color: var(--purple);
}

button, select {
  width: 100%;
  margin-bottom: 0.5rem;
  padding: 0.4rem;
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  background-color: white;
  color: var(--purple);
  border: 1px solid var(--purple);
  border-radius: 0;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  outline: none;
}

button:not(:disabled):hover,
button:not(:disabled):focus,
select:not(:disabled):hover,
select:focus,
input[type=number]:hover,
input[type=number]:focus,
input[type=checkbox]:focus {
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.25);
}

button:not(:disabled):active {
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.25), inset 2px 2px 5px rgba(0, 0, 0, 0.2);
  background-color: #fafafa;
  color: var(--purple-dark);
}

/* button-link is a button element that looks like a link */
button.button-link {
  display: block;
  padding: 0;
  border: none;
  font-size: 10px;
  text-decoration: none;
  background-color: transparent;
  box-shadow: none;
  font-weight: 400;
}

button.button-link:hover,
button.button-link:active,
button.button-link:focus {
  box-shadow: none;
  background-color: transparent;
  text-decoration: underline;
}

select {
  height: 30px;
  appearance: none;
  -webkit-appearance: none;
}

select[multiple]:focus option:checked {
  background: var(--purple);
  color: white;
}

.flex button,
.flex label {
  width: calc(50% - 0.25rem);
  align-self: flex-end;
}

.flex-checkbox {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

/* PEN section */

.pen-label {
  width: calc(50% - 0.25rem);
}

/* PAPER section */

.paper-sizes {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.paper-label {
  width: 44%;
  margin-bottom: 0;
}

.paper-sizes__swap {
  width: 10%;
  margin-bottom: 16px;
  cursor: pointer;
  fill: var(--purple);
}
.paper-sizes__swap:hover {
  fill: var(--purple-dark);
}

.layer-select {
  height: 100px;
  background-color: white;
  border: 1px solid var(--purple);
  color: var(--purple);
}
.layer-select:hover {
  background-color: white;
  cursor: default;
}

.spacer {
  height: 200px;
}

/* MORE section */

summary {
  outline: none;
  cursor: pointer;
}

summary:focus {
  color: var(--purple-dark);
}

.horizontal-labels label {
  display: block;
  position: relative;
}
.horizontal-labels label::after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 28px;
  border-right: 1px solid var(--purple);
}

.horizontal-labels img {
  position: absolute;
  padding: 4px;
  width: 28px;
  height: 28px;
  border-right: 1px solid var(--purple);
  /*opacity: 0.5;*/
}
.horizontal-labels input {
  padding-left: 32px;
}

/* PLOT section */

.duration {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.section-body__plot button {
  padding: 0.4rem;
  font-size: 18px;
}
.section-body__plot button:disabled {
  /*background-color: var(--purple-light);*/
  /*color: var(--purple-light);*/
  cursor: default;
}

.replan-button {
  /*color: var(--purple);*/
}

.plot-button {
  color: white;
  background-color: var(--teal);
  border: 1px solid var(--teal-dark);
}
.plot-button:not(:disabled):active {
  color: white;
  background-color: var(--teal);
}
.plot-button:disabled {
  color: var(--teal-light);
  background-color: white;
}
.plot-button--plotting {
  background-color: var(--teal-light);
}

.button-row {
  display: flex;
}
.button-row > *:not(:first-child) {
  margin-left: 10px;
}

.cancel-button {
  background-color: white;
  color: var(--purple-light);
}
.cancel-button--active {
  color: var(--purple);
}


/* UTILS */

.purple { color: var(--purple); }
.teal { color: var(--teal); }
.teal-dark { color: var(--teal-dark); }
.red { color: var(--red); }

.reg { font-weight: 400; }

.flex {
  display: flex;
  justify-content: space-between;
}

.info-disconnected {
  text-align: center;
  color: var(--red);
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,MAAM;EACN,OAAO;AACT;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;;EAEhB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,SAAS;EACT,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,+BAA+B;EAC/B,oCAAoC;EACpC,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;EAC/B,uBAAuB;EACvB,0CAA0C;EAC1C,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;EACT,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,aAAa;AACf;;AAEA;;;;;;;EAOE,2CAA2C;AAC7C;;AAEA;EACE,iFAAiF;EACjF,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,2DAA2D;AAC3D;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,gBAAgB;;AAEhB;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;;AAElB;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA,iBAAiB;;AAEjB;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA,iBAAiB;;AAEjB;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,yCAAyC;EACzC,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;AACpC;AACA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,oBAAoB;AACtB;;;AAGA,UAAU;;AAEV,UAAU,oBAAoB,EAAE;AAChC,QAAQ,kBAAkB,EAAE;AAC5B,aAAa,uBAAuB,EAAE;AACtC,OAAO,iBAAiB,EAAE;;AAE1B,OAAO,gBAAgB,EAAE;;AAEzB;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[":root {\n  --teal: #75D5CD;\n  --teal-light: #DCF4F2;\n  --teal-dark: #3F9991;\n  --purple: #8E75B6;\n  --purple-light: #E3DCED;\n  --purple-dark: #604987;\n  --red: #DE7272;\n  --panel-width: 260px;\n}\n\nbody {\n  font-family: 'Work Sans', sans-serif;\n  font-size: 14px;\n  color: var(--purple);\n  background-color: #f6f6f6;\n}\n\nbody, html, #app {\n  height: 100%;\n  margin: 0;\n}\n\nbody.dragover {\n  background-color: var(--teal);\n}\n\n* {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nstrong {\n  font-weight: 900;\n}\n\n.root {\n  display: flex;\n  align-items: stretch;\n  height: 100%;\n}\n\npath {\n  stroke: black;\n  fill: transparent;\n}\n\n.preview-area {\n  position: relative;\n  flex: 1 1 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n.preview {\n  box-shadow: 3px 3px 15px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n  background-color: white;\n  position: relative;\n}\n\n.preview-loader {\n  align-items: center;\n  background: rgba(0, 0, 0, 0.2);\n  color: whitesmoke;\n  display: flex;\n  font-size: 36px;\n  font-weight: bold;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.preview > svg {\n  display: block;\n  contain: strict;\n}\n\n.preview > svg:not(:first-child) {\n  position: absolute;\n  transform: translateZ(0.001px);\n  top: 0;\n  left: 0;\n}\n\n.dragover .drag-target {\n  opacity: 0;\n}\n\n.drag-target {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.drag-target-message {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: whitesmoke;\n  font-weight: bold;\n  font-size: 36px;\n}\n\n.control-panel {\n  position: relative;\n  flex: 0 0 var(--panel-width);\n  width: var(--panel-width);\n  background-color: white;\n  overflow-y: auto;\n\n  box-shadow: 3px 3px 15px rgba(0, 0, 0, 0.2);\n}\n\n.control-panel-bottom {\n  position: fixed;\n  bottom: 0;\n  width: var(--panel-width);\n  padding-bottom: 0.5rem;\n  background-color: white;\n}\n\n.control-panel-bottom .section-header {\n  padding-top: 0.25rem;\n}\n\n.saxi-title {\n  margin: 0 1rem;\n  padding-top: 0.5rem;\n  font-size: 36px;\n  font-weight: 900;\n  text-align: center;\n  user-select: none;\n}\n.disconnected .saxi-title {\n  text-decoration-line: line-through;\n}\n\n.section-header {\n  margin-bottom: 1rem;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid var(--purple-light);\n  font-size: 18px;\n  font-weight: 900;\n  text-align: center;\n  user-select: none;\n}\n\n.section-body {\n  padding: 0 1rem;\n}\n\n/* INPUTS */\n\nform {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n}\n\nlabel {\n  font-size: 10px;\n  text-align: center;\n  line-height: 1.6;\n  user-select: none;\n}\n\ninput[type=number] {\n  width: 100%;\n  padding: 0.3rem;\n  margin-bottom: 0.5rem;\n  border: 1px solid var(--purple);\n  font-family: 'Work Sans', sans-serif;\n  font-size: 14px;\n  color: var(--purple);\n  background-color: white;\n  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n  outline: none;\n}\n\ninput[type=checkbox] {\n  position: relative;\n  appearance: none;\n  -webkit-appearance: none;\n  width: 18px;\n  height: 18px;\n  margin: 0 0.5rem 0 0;\n  border: 1px solid var(--purple);\n  background-color: white;\n  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n  outline: none;\n  cursor: pointer;\n}\n\ninput[type=checkbox]:checked:after {\n  display: block;\n  position: absolute;\n  top: 3px;\n  right: 3px;\n  bottom: 3px;\n  left: 3px;\n  content: '';\n  background-color: var(--purple);\n}\n\nbutton, select {\n  width: 100%;\n  margin-bottom: 0.5rem;\n  padding: 0.4rem;\n  font-family: 'Work Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  background-color: white;\n  color: var(--purple);\n  border: 1px solid var(--purple);\n  border-radius: 0;\n  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  outline: none;\n}\n\nbutton:not(:disabled):hover,\nbutton:not(:disabled):focus,\nselect:not(:disabled):hover,\nselect:focus,\ninput[type=number]:hover,\ninput[type=number]:focus,\ninput[type=checkbox]:focus {\n  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.25);\n}\n\nbutton:not(:disabled):active {\n  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.25), inset 2px 2px 5px rgba(0, 0, 0, 0.2);\n  background-color: #fafafa;\n  color: var(--purple-dark);\n}\n\n/* button-link is a button element that looks like a link */\nbutton.button-link {\n  display: block;\n  padding: 0;\n  border: none;\n  font-size: 10px;\n  text-decoration: none;\n  background-color: transparent;\n  box-shadow: none;\n  font-weight: 400;\n}\n\nbutton.button-link:hover,\nbutton.button-link:active,\nbutton.button-link:focus {\n  box-shadow: none;\n  background-color: transparent;\n  text-decoration: underline;\n}\n\nselect {\n  height: 30px;\n  appearance: none;\n  -webkit-appearance: none;\n}\n\nselect[multiple]:focus option:checked {\n  background: var(--purple);\n  color: white;\n}\n\n.flex button,\n.flex label {\n  width: calc(50% - 0.25rem);\n  align-self: flex-end;\n}\n\n.flex-checkbox {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n/* PEN section */\n\n.pen-label {\n  width: calc(50% - 0.25rem);\n}\n\n/* PAPER section */\n\n.paper-sizes {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n\n.paper-label {\n  width: 44%;\n  margin-bottom: 0;\n}\n\n.paper-sizes__swap {\n  width: 10%;\n  margin-bottom: 16px;\n  cursor: pointer;\n  fill: var(--purple);\n}\n.paper-sizes__swap:hover {\n  fill: var(--purple-dark);\n}\n\n.layer-select {\n  height: 100px;\n  background-color: white;\n  border: 1px solid var(--purple);\n  color: var(--purple);\n}\n.layer-select:hover {\n  background-color: white;\n  cursor: default;\n}\n\n.spacer {\n  height: 200px;\n}\n\n/* MORE section */\n\nsummary {\n  outline: none;\n  cursor: pointer;\n}\n\nsummary:focus {\n  color: var(--purple-dark);\n}\n\n.horizontal-labels label {\n  display: block;\n  position: relative;\n}\n.horizontal-labels label::after {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 28px;\n  border-right: 1px solid var(--purple);\n}\n\n.horizontal-labels img {\n  position: absolute;\n  padding: 4px;\n  width: 28px;\n  height: 28px;\n  border-right: 1px solid var(--purple);\n  /*opacity: 0.5;*/\n}\n.horizontal-labels input {\n  padding-left: 32px;\n}\n\n/* PLOT section */\n\n.duration {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0.5rem;\n}\n\n.section-body__plot button {\n  padding: 0.4rem;\n  font-size: 18px;\n}\n.section-body__plot button:disabled {\n  /*background-color: var(--purple-light);*/\n  /*color: var(--purple-light);*/\n  cursor: default;\n}\n\n.replan-button {\n  /*color: var(--purple);*/\n}\n\n.plot-button {\n  color: white;\n  background-color: var(--teal);\n  border: 1px solid var(--teal-dark);\n}\n.plot-button:not(:disabled):active {\n  color: white;\n  background-color: var(--teal);\n}\n.plot-button:disabled {\n  color: var(--teal-light);\n  background-color: white;\n}\n.plot-button--plotting {\n  background-color: var(--teal-light);\n}\n\n.button-row {\n  display: flex;\n}\n.button-row > *:not(:first-child) {\n  margin-left: 10px;\n}\n\n.cancel-button {\n  background-color: white;\n  color: var(--purple-light);\n}\n.cancel-button--active {\n  color: var(--purple);\n}\n\n\n/* UTILS */\n\n.purple { color: var(--purple); }\n.teal { color: var(--teal); }\n.teal-dark { color: var(--teal-dark); }\n.red { color: var(--red); }\n\n.reg { font-weight: 400; }\n\n.flex {\n  display: flex;\n  justify-content: space-between;\n}\n\n.info-disconnected {\n  text-align: center;\n  color: var(--red);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
